import React, { useMemo, useState } from "react";

import ProfileCard from "../../components/instructor/ProfileCard";
import InstructorLayout from "../../layouts/InstructorLayout";
import DashboardSessions from "../../components/instructor/DashboardSessions";
import SessionsTable from "../../components/instructor/SessionsTable";
import {
  BookOpen,
  PlayCircle,
  Trophy,
  Users,
} from "../../components/instructor/icons";
import StudentsFeedback from "../../components/instructor/StudentsFeedback";
import { useNavigate } from "react-router-dom";
import { useGetMyAssignedCoursesQuery } from "../../services/instructor/instructor";
import AssignedCourses from "../../components/instructor/AssignedCourses";

const notifications = [
  {
    title: "New Demo Session Scheduled!",
    description:
      "Your demo session has been scheduled by admin with Michael Chen",
    time: "1/17/2025 at 4:00 PM - 5:00 PM • Data Science Fundamentals",
  },
  {
    title: "Live Sessions Scheduled!",
    description:
      "Your live sessions has been scheduled by admin with Michael Chen",
    time: "1/17/2025 at 4:00 PM - 5:00 PM • Data Science Fundamentals",
  },
];

const Dashboard = () => {
  let loggedInUser = null;
  try {
    loggedInUser = JSON.parse(localStorage.getItem("loggedInUser") || "null");
  } catch {
    loggedInUser = null;
  }
  const navigate = useNavigate();

  const { data: assignedCoursesResponse } = useGetMyAssignedCoursesQuery({
    page: 1,
    limit: 10,
  });
 
  const assignedCourses = assignedCoursesResponse?.data || [];

  

  

  const stats = [
    {
      title: "In-Process",
      value: 2,
      icon: <PlayCircle />,
      bg: "bg-[#FFEEE8]",
    },
    {
      title: "Total Courses",
      value: assignedCourses.length,
      icon: <BookOpen />,
      bg: "bg-[#E1F7E3]",
    },
    {
      title: "Students",
      value: 0,
      icon: <Users />,
      bg: "bg-[#FFF0F0]",
    },
    {
      title: "Completed Courses",
      value: 6,
      icon: <Trophy />,
      bg: "bg-[#E1F7E3]",
    },
  ];
  return (
    <InstructorLayout>
      <div className="overflow-x-hidden px-4 pb-10 pt-4 sm:px-6 sm:pt-6 lg:px-8 2xl:pr-[60px] 2xl:pl-9">
        {/* Profile Banner */}
        <div className="flex flex-col gap-4 bg-[#089BC412] px-4 py-4 sm:flex-row sm:items-center sm:justify-between sm:gap-6 sm:px-6 sm:py-3 lg:px-10">
          <div className="flex min-w-0 items-center gap-4 sm:gap-6">
            <img
              src={loggedInUser?.profilePicture}
              alt={loggedInUser?.firstName}
              className="h-12 w-12 shrink-0 rounded-full object-cover sm:h-14 sm:w-14"
            />

            <div className="min-w-0">
              <h2 className="truncate text-lg font-semibold leading-[26px] text-[#089BC4] sm:text-xl">
                {loggedInUser?.firstName} {loggedInUser?.lastName}
              </h2>

              <p className="truncate text-sm leading-[22px] tracking-[-1%] text-[#089BC4]">
                {loggedInUser?.email}
              </p>
            </div>
          </div>

          <button
            type="button"
            onClick={() => navigate("/instructor/profile/edit-profile")}
            className="w-full shrink-0 rounded-full bg-white px-[22px] py-2 text-base font-semibold tracking-[-0.8%] text-[#089BC4] sm:w-auto sm:py-1"
          >
            Edit Profile
          </button>
        </div>

        {/* Stats */}
        <div className="mt-5 grid grid-cols-1 gap-4 min-[480px]:grid-cols-2 sm:mt-[30px] sm:gap-5 xl:grid-cols-4 lg:gap-6 2xl:gap-12">
          {stats.map((item, index) => (
            <ProfileCard
              key={index}
              icon={item.icon}
              value={item.value}
              title={item.title}
              bg={item.bg}
            />
          ))}
        </div>

        {/* Notifications */}
        {/* <div className="mt-3 space-y-3">
          {notifications.map((item, index) => (
            <DashboardSessions
              key={index}
              title={item.title}
              description={item.description}
              time={item.time}
            />
          ))}
        </div> */}

        <div className="mt-4 flex w-full min-w-0 flex-col gap-4 xl:flex-row xl:items-start">
          <div className="min-w-0 w-full flex-1 space-y-4">
            {assignedCourses.length > 0 && (
              <AssignedCourses courses={assignedCourses} />
            )}
            <SessionsTable />
          </div>

          <div className="w-full shrink-0 xl:max-w-[448px]">
            <StudentsFeedback />
          </div>
        </div>
      </div>
    </InstructorLayout>
  );
};

export default Dashboard;
